/**
 * NYSERDA OsEM has moved to Energy Optimizer (EOFDD) — 2026-10-18 (consolidation plan step 8).
 * The pump app's OsEM pages show this notice with a link to the same work in EOFDD. The old page can still be opened
 * for this browser session ("Open the old page anyway"), so nothing is lost while the move is checked.
 */
import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const EOFDD_BASE = "https://app.onitnetworking.com/eofdd";
const LEGACY_FLAG = "pump_osem_legacy_ok";

export function MovedToEofdd({ target, title, children }: { target: string; title: string; children: React.ReactNode }) {
  const [legacy, setLegacy] = useState(() => {
    try { return sessionStorage.getItem(LEGACY_FLAG) === "1"; } catch { return false; }
  });
  if (legacy) return <>{children}</>;
  return (
    <div className="flex items-center justify-center min-h-[70vh] p-4">
      <Card className="max-w-xl w-full">
        <CardHeader><CardTitle>{title} has moved to Energy Optimizer</CardTitle></CardHeader>
        <CardContent className="space-y-4 text-sm">
          <p>NYSERDA OsEM work (onboarding, proposals, AI writing, ECM analyses, Appendix P, glidepath, lighting auditor, engineering studies and the Energy Management Plan) now lives in Energy Optimizer in the ONIT suite. Proposals from this app were copied there.</p>
          <div className="flex flex-wrap gap-2">
            <Button onClick={() => window.location.assign(target)}>Open in Energy Optimizer</Button>
            <Button variant="outline" onClick={() => { try { sessionStorage.setItem(LEGACY_FLAG, "1"); } catch { /* private mode */ } setLegacy(true); }}>
              Open the old page anyway
            </Button>
          </div>
          <p className="text-xs text-muted-foreground">Sign in to the ONIT suite with the same account if asked.</p>
        </CardContent>
      </Card>
    </div>
  );
}

/** Wraps a pump OsEM page so it shows the notice first. */
export function movedToEofdd(Comp: React.ComponentType<any>, title: string, target: (params: Record<string, string>) => string) {
  return function Moved(props: { params?: Record<string, string> }) {
    return (
      <MovedToEofdd title={title} target={target(props.params || {})}>
        <Comp {...props} />
      </MovedToEofdd>
    );
  };
}
